import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Flex, Progress} from 'antd';


function SummaryComponent({record, background = "", textLabel = "", text = ""}) {
    let bgStyle = {
        background: background? background : "#FFFFFF"
    }
    let textStyleLabel = {
        color: textLabel? textLabel : "#696969"
    }
    let textStyle = {
        color: text? text : "#111111"
    }
    return (
        <div style={bgStyle} className="flex flex-col w-full flex-grow h-[110px] font-uregular p-[16px] rounded">
            <div style={textStyleLabel} className="text-sm mb-[8px]">{record.label}</div>
            <div className="flex flex-row items-center mb-[8px]">
                <div style={textStyle}  className="text-3xl font-ubold text-preblack">{record.value}</div>
                {record.expansion ? (
                    <img className="w-[24px] h-[24px] ml-[12px]"
                         src={`/images/${record.expansion === 'growth' ? 'increase' : 'decrease'}.svg`}/>
                ) : ''
                }
            </div>
        </div>
    );
}

export default SummaryComponent;
